import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Form,
  // Checkbox,
  // Select,
  Radio
} from 'antd';
import CommonButton from '../../common/Button';
import Input from '../../common/Input';
// import { themeColors } from '../../../constants/themes';
import { numRegExp } from '../../../constants/validNumberRegExp';

// const { Option } = Select;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 2em;
  & > .ant-form-item {
    margin-bottom: 0em;
  }
  & > .ant-form-item:not(:last-child) {
    margin-right: 2em;
  }
  & label {
    margin-bottom: 0px;
    font-weight: normal;
  }
  & .ant-form-item-label {
    padding-bottom: 2px;
  }
`;

// const BoxedNotification = styled.div`
//   background: ${themeColors.backgroundLightBlue};
//   padding: 1em;
//   margin-bottom: 0.5em;
//   .ant-row.ant-form-item {
//     margin-bottom: 0em;
//   }
// `;

const LinkButton = styled.a`
  color: grey;
  text-decoration: underline;
`;

@injectIntl
@Form.create()
class CompetitionEditForm extends Component {
  constructor() {
    super();
    /* eslint-disable */
    this.state = {
      isBreakEvenTouched: false,
      isOverrideChecked: true,
    };
    /* eslint-enable */
  }

  getDefaultValues = () => {
    const { getStrategyDefaultValues, form, type, sourceMarketplaceId } = this.props;
    getStrategyDefaultValues(type, sourceMarketplaceId).then(data => {
      form.setFieldsValue(data);
    });
  };

  saveChanges = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.saveNewPricing({ ...values, strategyType: this.props.pricing.strategyType });
      }
    });
  };

  render() {
    const {
      form,
      pricing,
      // sellersAccounts,
      // selectedAccountCode,
      intl
    } = this.props;
    const { getFieldDecorator } = form;
    const symbolStyle = { fontSize: '16px' };
    const RadioGroup = Radio.Group;
    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <FormattedMessage id="pricing.pricingName" defaultMessage="Pricing Name" />
          <LinkButton onClick={this.getDefaultValues}>
            {intl.formatMessage({ id: 'prising.getDefaults' })}
          </LinkButton>
        </div>
        <Row>
          <div className="title2">
            <FormattedMessage id="pricing.competition" defaultMessage="Competition" />
          </div>
        </Row>
        <Form layout="vertical" onSubmit={this.saveChanges} hideRequiredMark>
          <Row>
            <Form.Item
              label={<FormattedMessage id="common.breakEven" defaultMessage="Break Even" />}
            >
              {getFieldDecorator('breakEven', {
                initialValue: pricing.breakEven,
                rules: [
                  {
                    required: true,
                    pattern: numRegExp,
                    message: intl.formatMessage({ id: 'pricing.requiredNumber' }),
                  },
                ],
              })(
                <Input
                  width="12.3em"
                  onChange={() => {
                    /* eslint-disable */
                    this.setState({ isBreakEvenTouched: true });
                    /* eslint-enable */
                  }}
                  type="number"
                />,
              )}
              <span style={symbolStyle}>%</span>
            </Form.Item>

            <Form.Item
              label={
                <FormattedMessage id="pricing.minimalProfit" defaultMessage="Minimal Profit" />
              }
            >
              {getFieldDecorator('minimalProfit', {
                initialValue: pricing.minimalProfit,
                rules: [
                  { required: true, message: intl.formatMessage({ id: 'pricing.requiredNumber' }) },
                  {
                    pattern: numRegExp,
                    message: intl.formatMessage({ id: 'pricing.requiredNumber' }),
                  },
                ],
              })(<Input width="12.3em" type="number" />)}
            </Form.Item>
            <Form.Item
              label={
                <FormattedMessage id="pricing.optimalProfit" defaultMessage="Optimal Profit" />
              }
            >
              {getFieldDecorator('optimalProfit', {
                initialValue: pricing.optimalProfit,
                rules: [
                  { required: true, message: intl.formatMessage({ id: 'pricing.requiredNumber' }) },
                  {
                    pattern: numRegExp,
                    message: intl.formatMessage({ id: 'pricing.requiredNumber' }),
                  },
                ],
              })(<Input width="12.3em" type="number" />)}
            </Form.Item>
            <Form.Item style={{ paddingTop: '20px' }}>
              {getFieldDecorator('inPercents', { initialValue: pricing.inPercents })(
                <RadioGroup>
                  <Radio value>%</Radio>
                  <Radio value={false}>$</Radio>
                </RadioGroup>,
              )}
            </Form.Item>
          </Row>
          {/* <Row> */}
          {/* <Form.Item> */}
          {/* {getFieldDecorator('applyBreakEven', { */}
          {/* valuePropName: 'checked', */}
          {/* initialValue: false, */}
          {/* rules: [], */}
          {/* })( */}
          {/* <Checkbox disabled={!this.state.isBreakEvenTouched}> */}
          {/* <FormattedMessage */}
          {/* id="pricing.applyBreakEvenChangeToAllPricings" */}
          {/* defaultMessage="Apply Break Even change to all pricing strategies within this account" */}
          {/* /> */}
          {/* </Checkbox>, */}
          {/* )} */}
          {/* </Form.Item> */}
          {/* </Row> */}
          {/* <Row> */}
          {/* <div> */}
          {/* <FormattedMessage id="pricing.listedItems" defaultMessage="Listed Items" /> */}
          {/* <a> {pricing.itemsCount}</a> */}
          {/* </div> */}
          {/* </Row> */}
          {/* <Row> */}
          {/* <Form.Item> */}
          {/* {getFieldDecorator('applyToItems', { */}
          {/* valuePropName: 'checked', */}
          {/* initialValue: false, */}
          {/* rules: [], */}
          {/* })( */}
          {/* <Checkbox> */}
          {/* <FormattedMessage */}
          {/* id="pricing.applyToAlreadyListed" */}
          {/* defaultMessage="Also apply changes to items already listed" */}
          {/* /> */}
          {/* </Checkbox>, */}
          {/* )} */}
          {/* </Form.Item> */}
          {/* </Row> */}
          {/* <Row> */}
          {/* <BoxedNotification> */}
          {/* <FormattedMessage */}
          {/* id="pricing.overrideChangeStrategyCrossAccounts" */}
          {/* defaultMessage="Please note that by saving you are overriding the default settings for this pricing strategy. Don't worry, you can always restore to defult" */}
          {/* /> */}
          {/* <Row style={{ justifyContent: 'space-between', margin: '0.5em 0' }}> */}
          {/* <Form.Item> */}
          {/* {getFieldDecorator('overrideAccounts', { */}
          {/* valuePropName: 'checked', */}
          {/* initialValue: false, */}
          {/* rules: [], */}
          {/* })( */}
          {/* <Checkbox */}
          {/* onChange={e => this.setState({ isOverrideChecked: e.target.checked })} */}
          {/* > */}
          {/* <FormattedMessage */}
          {/* id="pricing.overrideCheckboxLabel" */}
          {/* defaultMessage="Override Fixed Profit pricing strategy for these accounts as well" */}
          {/* /> */}
          {/* </Checkbox>, */}
          {/* )} */}
          {/* </Form.Item> */}
          {/* <Form.Item style={{ marginRight: '0' }}> */}
          {/* {getFieldDecorator('sellerAccountCodes', { initialValue: [] })( */}
          {/* <Select */}
          {/* maxTagCount={1} */}
          {/* mode="multiple" */}
          {/* optionFilterProp="label" */}
          {/* style={{ width: '14em' }} */}
          {/* disabled={!this.state.isOverrideChecked} */}
          {/* > */}
          {/* {sellersAccounts */}
          {/* .filter(accountObj => accountObj.id !== selectedAccountCode) */}
          {/* .map(accountObj => ( */}
          {/* <Option */}
          {/* key={accountObj.name} */}
          {/* value={accountObj.id} */}
          {/* label={accountObj.name} */}
          {/* > */}
          {/* {accountObj.name} */}
          {/* </Option> */}
          {/* ))} */}
          {/* </Select>, */}
          {/* )} */}
          {/* </Form.Item> */}
          {/* </Row> */}
          {/* </BoxedNotification> */}
          {/* </Row> */}
          <Row style={{ justifyContent: 'flex-end' }}>
            <CommonButton htmlType="submit" type="normal" clickHandler={() => {}}>
              <FormattedMessage id="pricing.saveNewPricing" defaultMessage="Save New Pricing" />
            </CommonButton>
          </Row>
        </Form>
      </div>
    );
  }
}

CompetitionEditForm.propTypes = {
  form: PropTypes.object,
  intl: PropTypes.object,
  pricing: PropTypes.object,
  // sellersAccounts: PropTypes.array,
  // selectedAccountCode: PropTypes.string,
  saveNewPricing: PropTypes.func,
  getStrategyDefaultValues: PropTypes.func,
  type: PropTypes.string,
  sourceMarketplaceId: PropTypes.string,
};

export default CompetitionEditForm;
